import { useEffect, useMemo, useState } from 'react';
import type {
  GenericOption,
  SmartConnector,
  SmartConnectorBase,
} from 'pages/SmartConnectors/types';
import { isCSVLoadStep } from '../helpers';

export const useScope = (
  { headers, flow }: SmartConnector | SmartConnectorBase,
  useRunSmartconnectorScopes?: boolean
) => {
  const [scope, setScope] = useState<string>(Object.keys(headers || {})[0]);

  useEffect(() => {
    setScope((prev) => prev || Object.keys(headers || {})[0]);
  }, [headers]);

  const scopeOptions = useMemo(() => {
    const scopes = Object.keys(headers || {}).map((scope) => ({
      value: scope,
      label: scope,
    }));
    if (useRunSmartconnectorScopes && flow.loads?.length) {
      scopes.push(
        ...flow.loads.reduce<GenericOption[]>((acc, load) => {
          if (!isCSVLoadStep(load) && load.return_scopes?.length) {
            acc.push(
              ...load.return_scopes.map((returnScope) => ({
                value: returnScope.name,
                label: returnScope.name,
              }))
            );
          }
          return acc;
        }, [])
      );
    }
    return scopes;
  }, [headers, flow.loads, useRunSmartconnectorScopes]);

  const onChangeScope = ({ value }: GenericOption) => {
    setScope(value);
  };

  return { scope, setScope, scopeOptions, onChangeScope };
};
